import $ from 'jquery'

export default {
  getModalData(endpointParams) {
    const params = {
      ...Silverfin.jsonParams,
      ledger_id: endpointParams.ledgerId,
      id: endpointParams.reconciliationTextId,
      _options: true,
    }

    const url =
      Silverfin.Routes.copy_data_ledger_reconciliation_text_path(params)

    return $.get(url)
  },
  copyLedger(endpointParams) {
    const params = {
      ...Silverfin.jsonParams,
      ledger_id: endpointParams.ledgerId,
      id: endpointParams.reconciliationTextId,
      from_ledger: endpointParams.fromLedger,
      _options: true,
    }

    const url = Silverfin.Routes.copy_ledger_reconciliation_text_path(params)

    return $.post(url)
  },
}
